import { type RootState } from '../../../rmsReduxStore/rmsStore'

export default function getAcVersionReleasesReducer (state: RootState): AcVersionReleaseState {
  return state.acVersionReleasesReducer
}
